'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDayEpoch = require('./xDayEpoch');

var _xDayEpoch2 = _interopRequireDefault(_xDayEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return (0, _xDayEpoch2.default)(-29);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/last30DaysEpoch.js
// module id = 65
// module chunks = 0